import { LoadStatus } from '../load-status';

/**
 * Feature key under which the config slice is registered in the root store.
 */
export const CONFIG_FEATURE_KEY = 'config';

/**
 * Serializable config storage: a plain key -> value map mirroring the backend
 * ConfigSet. Getters only ever read a value by key, so the category is not stored.
 * `status` tracks whether the backend data has been loaded (see {@link LoadStatus}).
 */
export type ConfigState = Readonly<{
    configValues: Record<string, string>;
    status: LoadStatus;
}>;

export const initialConfigState: ConfigState = {
    configValues: {},
    status: LoadStatus.Idle,
};
